import React from 'react';
import './Footer.scss';
import Logo from '../../assets/images/sjmp_logo-removebg-preview.png';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo and Address Section */}
        <div className="footer-logo">
          <img
            src={Logo}
            alt="SJMP College Logo"
            className="logo"
          />
          <address>
            Ward No.1, Halepete Road, Birur, Kadur Talluk, Chikkamagaluru
            <br />
            District-577116
          </address>
          <p>
            <i className="fa fa-envelope"></i>{' '}
            <a href="mailto:353sjmpbirur@gmail.com">353sjmpbirur@gmail.com</a>
          </p>
          <p>
            <i className="fa fa-phone"></i>{' '}
            <a href="tel:+08267295302">(+08267) 295302</a>
          </p>
          <p>
            <i className="fa fa-phone"></i>{' '}
            <a href="tel:+08267295302">(+91) 9036447506</a>
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
              <li>
                <a href="/admission">Admission</a>
              </li>
              <li>
                <a href="/grievance">Grievance</a>
              </li>
              <li>
                <a href="/nss">NSS</a>
              </li>
            </ul>
          </div>

          {/* Route Map */}
          <div className="route-map">
            <h4>Route Map</h4>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3877.899689255035!2d75.96888221094707!3d13.602938300666885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbae9d9b17d6db7%3A0xc7fc3959df823f83!2sSJM%20POLYTECHNIC%20(GOVT.%20AIDED)%2C%20BIRUR!5e0!3m2!1sen!2sin!4v1733658733855!5m2!1sen!2sin"
              title="SJMP College Map"
              width="300"
              height="200"
              allowFullScreen={true}
              loading="lazy"
              style={{ border: '0' }}
            ></iframe>
          </div>
        </div>
      </div>

      {/* Footer Credits */}
      <div className="footer-credits">
        <p>
          &copy; SJMP College. All Rights Reserved. Design & Developed by{' '}
          <a
            href="https://www.prajnansoftwares.com/aboutus"
            target="_blank"
            rel="noreferrer"
          >
            Prajnan Software Pvt Ltd.
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

